import { RenewVisaPresentEmployeeApplicationPage } from "@/features/renew-visa/pages/RenewVisaPresentEmployeeApplication";

const RenewVisaPresentEmployeeApplication = () => {
  return <RenewVisaPresentEmployeeApplicationPage />;
};

export default RenewVisaPresentEmployeeApplication;
